import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PartnersService, Partner } from '../../../services/partners/partners.service';
import { UiAlertService } from '../../../services/ui-alert/ui-alert.service';
import { CobrandingFormComponent } from './cobranding-form.component';

@Component({
    selector: 'app-cobranding-list',
    templateUrl: './cobranding-list.component.html',
    styleUrls: ['./cobranding-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CobrandingListComponent implements OnInit {
  partners: Partner[] = [];
  loading = false;

  constructor(
    private partnersService: PartnersService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private uiAlertService: UiAlertService,
  ) {}

  ngOnInit(): void {
    this.loadPartners();
  }

  async loadPartners(): Promise<void> {
    this.loading = true;
    try {
      const partners = await this.partnersService.getAllPartners();
      const cacheBust = `?${Date.now()}`;
      this.partners = (partners || []).map((partner) => ({
        ...partner,
        logoUrl: partner.logoUrl ? `${partner.logoUrl}${cacheBust}` : partner.logoUrl,
      }));
    } catch (error) {
      console.error('Error loading partners', error);
      this.snackBar.open('Error loading co-branding list', 'Close', { duration: 2000 });
    } finally {
      this.loading = false;
    }
  }

  addCobranding(): void {
    const dialogRef = this.dialog.open(CobrandingFormComponent, {
      width: '960px',
      maxWidth: '95vw',
      data: {},
    });
    dialogRef.afterClosed().subscribe((changed) => {
      if (changed) {
        this.loadPartners();
      }
    });
  }

  editCobranding(partner: Partner): void {
    const dialogRef = this.dialog.open(CobrandingFormComponent, {
      width: '960px',
      maxWidth: '95vw',
      data: { partner },
    });
    dialogRef.afterClosed().subscribe((changed) => {
      if (changed) {
        this.loadPartners();
      }
    });
  }

  async deleteCobranding(partner: Partner): Promise<void> {
    const confirm = await this.uiAlertService.presentAlertConfirm(`Are you sure you want to delete ${partner.name}?`);
    if (!confirm) {
      return;
    }
    try {
      await this.partnersService.deletePartner(partner);
      this.snackBar.open('Co-branding deleted', 'Close', { duration: 2000 });
      this.loadPartners();
    } catch (error) {
      console.error('Error deleting co-branding', error);
      this.snackBar.open('Error deleting co-branding', 'Close', { duration: 2000 });
    }
  }

  async clone(partner: Partner): Promise<void> {
    const clone: any = { ...partner };
    clone.name = `${partner.name} - COPY`;
    clone.domain = '';
    clone.shortName = '';
    clone.redirectUrl = null;
    clone.isClone = true;
    try {
      await this.partnersService.createPartner(clone);
      this.snackBar.open('Co-branding cloned', 'Close', { duration: 2000 });
      this.loadPartners();
    } catch (error) {
      console.error('Error cloning co-branding', error);
      this.snackBar.open('Error cloning co-branding', 'Close', { duration: 2000 });
    }
  }

  openUrl(url?: string): void {
    if (!url) {
      return;
    }
    window.open(`https://${url}`, '_blank');
  }
}
